import state from "./moduleCrewDataManagementState.js";
import mutations from "./moduleCrewDataManagementMutations.js";
import actions from "./moduleCrewDataManagementActions";
import getters from "./moduleCrewDataManagementGetters";

export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters,
};
